import React from "react";
import { FormLayout } from "playground/cms/Form";
import { ListLayout } from "playground/cms/List";
import Resources from "playground/cms/views/Resources";
import FlatsForm from "./FlatsForm";
import ListItem from "./ListItem";
import Filters from "./Filters";
import { Search } from "playground/cms/List/Filter";
//import PropTypes from 'prop-types';

import "./style.css";

export function Flats(props) {
    const { isDraft, type } = props;
    const url = "apartments/flats?order=building,code asc";
    return (
        <Resources {...props} url={url} ListItem={ListItem}>
            <ListLayout>
                <ListLayout.Filter>
                    <div className={"rows gap-md"}>
                        <Search type={type} name={"search"} />
                        <Filters {...props} />
                    </div>
                </ListLayout.Filter>
                <ListLayout.Header>
                    <ListLayout.Header.Icons prepend={true}>
                        <ListLayout.Header.Filter />
                    </ListLayout.Header.Icons>
                </ListLayout.Header>
            </ListLayout>
            <FormLayout>
                <FormLayout.Content replace={true}>
                    <FormLayout.Tab id={"flat"} label={"Mieszkanie"}>
                        <FlatsForm {...props} />
                    </FormLayout.Tab>
                </FormLayout.Content>
            </FormLayout>
        </Resources>
    );
}

Flats.propTypes = {};

Flats.defaultProps = {};

export default Flats;
